import { ApolloClient, DefaultOptions, ApolloClientOptions } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { createHttpLink } from 'apollo-link-http'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'

// import { getAuth0 } from '@/lib/auth0Bridge'

function getAuth(tokenName) {
  if (typeof window !== 'undefined') {
    // get the authentication token from local storage if it exists
    const token = window.localStorage.getItem(tokenName)
    // return the headers to the context so httpLink can read them
    return token ? `Bearer ${token}` : ''
  }
}

const authLink = setContext(async (_, { headers }) => {
  const Authorization = await getAuth('apollo-token')
  const authorizationHeader = Authorization ? { Authorization } : {}
  return {
    headers: {
      ...headers,
      ...authorizationHeader
    }
  }
})

const httpLink = createHttpLink({
  uri: process.env.VUE_APP_API_URI
})

const cache = new InMemoryCache({
  addTypename: false
})

const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore'
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none'
  },
  mutate: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'none'
  }
}

const errorLink = onError(({
  graphQLErrors,
  networkError
}) => {
  if (graphQLErrors) {
    graphQLErrors.map(({
      message,
      locations,
      path
    }) =>
      console.log(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
    )
  }

  if (networkError) {
    console.log('[Network error]:', networkError)
  }
})

const link = ApolloLink.from([
  errorLink,
  authLink,
  httpLink
])

const options: ApolloClientOptions<any> = {
  link,
  cache,
  connectToDevTools: true,
  defaultOptions
}

const client = new ApolloClient(options)

export { client }
